<template>
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.7597 3.33887H1.7403C1.46977 3.33887 1.31871 3.6245 1.48625 3.8195L5.99595 9.04878C6.12504 9.19846 6.37359 9.19846 6.50405 9.04878L11.0138 3.8195C11.1813 3.6245 11.0302 3.33887 10.7597 3.33887Z"
      fill="currentColor"
    />
  </svg>
</template>
